import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'do0019',
    ecrans: ['00-2'],
    params: [
        '?temcleintdes',
        '?temcod',
        '?temdsc'
    ]
});
